export const footerItems = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Pricing',
    link: '/pricing?from=footer',
  },
  {
    label: 'About',
    link: '/about',
  },
  {
    label: 'Contact',
    link: '/contact?from=footer',
  },
  {
    label: 'Blog',
    link: '/blog',
  },
  {
    label: 'Self-Guided Demo',
    link: '/docs/demo?from=footer',
  },
  {
    label: 'Documentation',
    link: '/docs',
  },
  {
    label: 'Security & Privacy',
    link: '/docs/security',
  },
  {
    label: 'Report Library',
    link: '/reports',
  },
  {
    label: 'Careers',
    link: '/careers',
  },
]